import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap} from './PlaySounds';
import {setGameScreenNumber} from '../actions/commonActions';
import {getSources,getMythsAndFacts} from '../actions/localActions'

class MainMenuScreen extends Component {

  UNSAFE_componentWillMount(){
    this.props.getSources(this.props.language);
    this.props.getMythsAndFacts(this.props.language);
}

      goToPlayScreen = () => {
        playButtonTap();
        this.props.setGameScreenNumber(1,1);
        this.props.history.push('/gamemode');//gamemode
      };
      goToAboutScreen = () => {
        playButtonTap();
        this.props.history.push('/about');
      };
      goToSourcesScreen = () => {
        playButtonTap();
        this.props.history.push('/sources');
      };
      goToSettingsScreen = () => {
        playButtonTap();
        this.props.history.push('/settings');
      };

      goToLanguageScreen = () => {
        playButtonTap();
        this.props.history.push('/languagescreen');
      };
    

    render() {
            return(
                <div className = "screen_background">
                  <div className = "buttons_wrapper">
                    <img src={"/game-skins/build-rev198-B6ETOYjbE/images_"+this.props.language+"/btn_play.png"} alt="" className="button home_button" onClick = {this.goToPlayScreen}/><br/>
                    <img src={"/game-skins/build-rev198-B6ETOYjbE/images_"+this.props.language+"/btn_about.png"} alt="" className="button home_button" onClick = {this.goToAboutScreen}/><br/>
                    <img src={"/game-skins/build-rev198-B6ETOYjbE/images_"+this.props.language+"/btn_settings.png"} alt="" className="button home_button" onClick = {this.goToSettingsScreen}/><br/>
                  </div>
                  
                </div>
            )
    }
}

MainMenuScreen.propTypes = {
  language:PropTypes.string.isRequired,
  getSources:PropTypes.func.isRequired,
  getMythsAndFacts:PropTypes.func.isRequired
}

const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  sources: state.localData.sources
});

export default connect(mapStateToProps,{setGameScreenNumber,getSources,getMythsAndFacts})(MainMenuScreen);
//export default withRouter(MainMenuScreen);



// WEBPACK FOOTER //
// ./src/components/MainMenuScreen.js